import { FETCH_LANGUAGES_SUCCEEDED } from '../actions/language';

const initialState = {
  languages: [],
};

export default function languageReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_LANGUAGES_SUCCEEDED:
      return {
        ...state,
        languages: payload.languages || [],
      };
    default:
      return state;
  }
}
